import { Stack, Typography } from '@mui/material'
import { formatTime } from '@operations/utils/format-date'
import { EmptyIndicator } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'

interface Props {
  date?: string | null
  isOnSameLine?: boolean
}
export const WorkInstructionTableDate = observer(({ date, isOnSameLine }: Props) => {
  if (!date) return <>{EmptyIndicator}</>

  return (
    <Stack flexDirection={isOnSameLine ? 'row' : 'column'} gap={0.5}>
      <Typography variant={'subtitle2'}>{dayjs(date).format('l')}</Typography>
      <Typography variant={'body2'} color={'secondary'}>
        {formatTime(date)}
      </Typography>
    </Stack>
  )
})
